import React, { useState } from 'react'

import { Stack, StackProps } from '../Stack'
import { Icon } from '../Icon'
import { Button } from '../Button'

export interface StarRatingInputProps extends StackProps {
  onChangeValue?: (rating: number) => void
  value?: number
}

export const StarRatingInput = ({ onChangeValue, value, ...restProps }: StarRatingInputProps) => {
  const [hoverIndex, setHoverIndex] = useState(null)
  const [clickIndex, setClickIndex] = useState(null)

  const _value = Math.round(value || 0)

  return (
    <Stack spacing="1px" direction="row" onMouseLeave={() => setHoverIndex(null)} {...restProps}>
      {new Array(5).fill(1).map((_, i) => {
        const _color = (hoverIndex == null ? i < _value : i <= hoverIndex)
          ? 'yellow.400'
          : 'gray.300'

        return (
          <Button
            variant="unstyled"
            onMouseOver={() => setHoverIndex(i)}
            onMouseDown={() => setClickIndex(i)}
            onMouseUp={() => setClickIndex(null)}
            onClick={() => onChangeValue && onChangeValue(i + 1)}
            title={`${i + 1} star${i > 0 ? 's' : ''}`}
            transform={clickIndex === i ? 'scale(1.4)' : hoverIndex === i ? 'scale(1.2)' : null}
            transition="200ms ease transform"
          >
            <Icon name="star" color={_color} fontSize="xl" />
          </Button>
        )
      })}
    </Stack>
  )
}

export default StarRatingInput
